import { DatePipe, DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2, ViewChild, ElementRef, PLATFORM_ID, signal } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { Subscription, take, timer } from 'rxjs';
import { CustomValidator } from 'src/app/_common/custom-validators';
import { URLS } from 'src/app/_config/api.config';
import { ApiService } from 'src/app/services/api-data.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CommonService } from 'src/app/services/common.service';
import { Will4HelpSectionCta, Will4HelpSectionItem } from '../../will4-help/will4-help-section.component';
import { Will4LegacyHelpItem } from '../../will4-legacy/will4-legacy-help-section.component';

@Component({
	selector: 'app-view-page-modal',
	templateUrl: './view-page-modal.component.html',
	styleUrls: ['./view-page-modal.component.scss']
})
export class ViewPageModalComponent implements OnInit {
	@Input() previewData: any;
	testimonailData: any;
	noTestimonial!: boolean;
	private subscription: Subscription = new Subscription();

	createAccountForm: any = UntypedFormGroup;
	submitted = false;
	passwordFocused = false;
	public passwordVisible = false;
	public confirmPasswordVisible = false;
	public isVerified: boolean = false;
	public isLoading: boolean = false;
	stars = [1, 2, 3, 4, 5];
	@Output() modalClose = new EventEmitter<boolean>();

	public countDown: any = Subscription;
	counter: any;
	tick = 1000;
	public code = null;
	canResendOtp: boolean = false;
	isTimer: boolean = false;
	// isCreatePwd: boolean = false;
	datePipe = new DatePipe('en-US');
	maxDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
	currentDate = new Date();
	specialCharacters: string = `!@#$%^&*()-+_=,.` + "`?:;{}|[]<>\"'~\\/";
	isLogin = false;
	currentTier = 0;
	isactiveInitiative: boolean = false;
	isactiveState: boolean = false;
	isactiveAboutUs: boolean = true;
	isactiveSupportMission: boolean = true;
	isSecondaryLandingPage: boolean = false;
	signUpFormSectionData: any;
	isReversed: boolean = false;

	showFullDescription: boolean = false;
showReadMore: boolean = false;
@ViewChild('desc') desc!: ElementRef<HTMLElement>;
@ViewChild('descMob') descMob!: ElementRef<HTMLElement>;
showReadMoreMob = false;   // mobile

resizeObs!: ResizeObserver;
mutationObs!: MutationObserver;

	//Add user form actions
	get f() { return this.createAccountForm.controls; }
	private checkedOverflow = false;

	constructor(private router: Router,
		private toastr: ToastrService,
		private dataService: ApiService,
		public renderer: Renderer2,
		private formBuilder: UntypedFormBuilder,
		private commonService: CommonService,
		private authService: AuthenticationService,
		@Inject(PLATFORM_ID) private platformId: Object,
		@Inject(DOCUMENT) private document: any,) { }

	aboutUsSectionData: any
	basicSectionData: any;
	supportMissionSectionData: any;
	intiativeSectionData: any;
	statisticSetionData: any;
	landingPageType!: string;
	isLongText = false;


		funeralHelpItems = signal<Will4HelpSectionItem[]>([
			{
				imageSrc: "../../../assets/images/plan9.jpg",
				imageAlt: "Document Your Final Wishes",
				title: "Request for a Funeral Mass",
				paragraphs: [
					"Document the desire for a traditional Catholic Funeral Mass, including preferred readings, hymns, prayers, and other meaningful liturgical details that reflect the Catholic faith and personal values, whether planning ahead for yourself or helping organize arrangements for a loved one. "
				]
			},
			{
				imageSrc: "../../../assets/images/funeral13.webp",
				imageAlt: "Free and Easy to Use",
				title: "Instructions for Burial in a Catholic Cemetery",
				paragraphs: [
					"Outline preferences for burial in a Catholic cemetery and include any special rites, prayers, or burial wishes that should be honored and communicated clearly to family members and parish staff. "
				]
			},
			{
				imageSrc: "../../../assets/images/plan11.webp",
				imageAlt: "Additional Benefits",
				title: "Guidance Regarding Cremation and Ashes",
				paragraphs: [
					"Clearly document burial or cremation preferences in accordance with Catholic teaching, including wishes regarding the respectful handling of cremated remains and avoiding the scattering of ashes."
				]
			},
			{
				imageSrc: "../../../assets/images/plan10.webp",
				imageAlt: "Free and Easy to Use",
				title: "Mass Intentions and Prayers",
				paragraphs: [
					"Include requests for Funeral Masses, prayers, or Mass intentions to be offered for the repose of the soul of yourself or a loved one following passing."
				]
			}
		]);
	
		healthcareDirectiveLegacyHelpItems: Will4LegacyHelpItem[] = [
		{
			imageSrc: "../../../assets/images/plan5.webp",
			imageAlt: "Create a Healthcare Directive",
			title: "Create a Healthcare Directive Step-by-Step",
			description: "Catholic Legacy guides users through the Healthcare Directive process in a simple and easy-to-understand format, helping document healthcare wishes and appoint trusted decision-makers."
		},
		{
			imageSrc: "../../../assets/images/plan6.webp",
			imageAlt: "Document Healthcare Wishes",
			title: "Document Healthcare Wishes Clearly",
			description: "Healthcare instructions, emergency contacts, faith-based preferences, and important medical guidance can all be organized in one accessible place.",
			reverse: true
		},
		{
			imageSrc: "../../../assets/images/plan7.webp",
			imageAlt: "Download and Share Documents",
			title: "Easily Download and Share Documents",
			description: "Completed Directives can be downloaded and shared with family members, health care providers, caregivers, or trusted loved ones when needed."
		},
		{
			imageSrc: "../../../assets/images/plan8.webp",
			imageAlt: "Review and Update Your Directive",
			title: "Review and Update Your Directive Anytime",
			description: "Healthcare needs and preferences can change over time. Directives can be reviewed and updated whenever necessary to help ensure wishes remain current and accessible.",
			reverse: true
		}
	];
	
		funeralLegacyHelpItems: Will4LegacyHelpItem[] = [
			{
				imageSrc: "../../../assets/images/slp_funeral_1.jpg",
				imageAlt: "Document Your Final Wishes",
				title: "Ease the Burden on Loved Ones",
				description: "Planning ahead helps reduce stress during a difficult time. Catholic Legacy makes it easy to create a Catholic Funeral Plan by documenting Funeral Mass preferences, USCCB-recommended readings, hymns, clergy preferences, prayers, and other important details, allowing loved ones to focus on prayer, healing, and supporting one another."
			},
			{
				imageSrc: "../../../assets/images/rosary.png",
				imageAlt: "Prevent Unwanted Decisions",
				title: "Rooted in Catholic Tradition",
				description: "Families can document Funeral Mass preferences, Sacraments, burial wishes, prayers, and spiritual guidance in a way that reflects Catholic teachings and honors personal faith and values.",
				reverse: true
			},
			{
				imageSrc: "../../../assets/images/slp_funeral_3.jpg",
				imageAlt: "Free and Easy to Use",
				title: "Easily Share with Family and Parish Staff",
				description: "Funeral plans can be shared with loved ones, parish staff, funeral homes, and others involved in the planning process. This helps improve communication and keeps important details organized during difficult times."
			},
			{
				imageSrc: "../../../assets/images/slp_funeral_4.jpg",
				imageAlt: "Additional Benefits",
				title: "Free, Secure, and Accessible Anytime",
				description: "This funeral planning resource is completely free, easy to use, and accessible online from anywhere. Plans can be reviewed and updated anytime as wishes or circumstances change.",
				reverse: true
			},
			// {
			// 	imageSrc: "../../../assets/images/funeral6.webp",
			// 	imageAlt: "Free and Easy to Use",
			// 	title: "Easily Share with Family and Parish Staff",
			// 	description: "Funeral plans can be shared with loved ones, parish staff, funeral homes, and others involved in the planning process. This helps improve communication and keeps important details organized during difficult times."
			// },
			// {
			// 	imageSrc: "../../../assets/images/funeral8.webp",
			// 	imageAlt: "Additional Benefits",
			// 	title: "Free, Secure, and Accessible Anytime",
			// 	description: "This funeral planning resource is completely free, easy to use, and accessible online from anywhere. Plans can be reviewed and updated anytime as wishes or circumstances change.",
			// 	reverse: true
			// }
		];
	
		funeralHelpCta: Will4HelpSectionCta | null = {
			title: "Start Your Journey Now",
			url: "planning"
		};

		healthcareDirectiveHelpCta: Will4HelpSectionCta | null = {
			title: "Get Started Now",
			url: "future"
		};

	ngOnInit() {

		this.initContactForm()
		this.fetchPreviewData()

		window.onpopstate = () => {
			window.location.href = '/neworgdashboard';
			// Your custom logic here
		};

		// setInterval(() => {
		// 	this.currentIndex = (this.currentIndex + 1) % this.testimonials.length;
		// }, 2000000);
        if (isPlatformBrowser(this.platformId)) {
		setInterval(() => {
			if (!this.carouselItems || this.carouselItems.length === 0) return;
			this.currentIndex = (this.currentIndex + 1) % this.carouselItems.length;
		}, 5000);
	   }
	}


	initContactForm() {
		this.createAccountForm = this.formBuilder.group({
			firstName: new UntypedFormControl(null, {
				validators: Validators.compose([Validators.required, CustomValidator.noWhiteSpaceValidator, CustomValidator.nameValidator]),
			}),
			lastName: new UntypedFormControl(null, {
				validators: Validators.compose([Validators.required, CustomValidator.noWhiteSpaceValidator, CustomValidator.nameValidator]),
			}),
			email: new UntypedFormControl(null, {
				validators: Validators.compose([Validators.required, CustomValidator.emailValidator]),
			}),
			password: new UntypedFormControl(null, {
				validators: Validators.compose([Validators.required, CustomValidator.passwordPatternValidator]),
			}),
			confirmPwd: new UntypedFormControl(null, { validators: this.confirmValidator }),
			// dateOfBirth: new FormControl(null, {
			//     validators: Validators.compose([Validators.required, CustomValidator.noWhiteSpaceValidator]),
			// }),
			agreement: new UntypedFormControl(null, {
				validators: Validators.compose([Validators.required]),
			}),
		});
	}
	onClosePreviewModal() {
		this.modalClose.emit(true)
	}

	features = [
		{
			img: './../../../../assets/images/will-landing-1.png',
			title: 'Online Estate Planning Made Easy',
			description: 'Our platform guides you through creating a comprehensive Will in less than 30 minutes. It’s free to use, and you can update it anytime as your circumstances change.'
		},
		{
			img: './../../../../assets/images/will6.webp',
			title: 'Simple and Secure',
			description: 'Catholic Legacy’s tool is designed to be easy for anyone to use, with step-by-step instructions and a secure platform that protects your information.'
		},
		{
			img: './../../../../assets/images/hands.webp',
			title: 'Aligned with Your Values',
			description: 'Catholic Legacy ensures that your Will reflects your values, whether you want to leave assets to your family, support your church, or donate to causes you care about.'
		},
		{
			img: './../../../../assets/images/files.webp',
			title: 'Unlimited Updates for Life',
			description: 'Your life changes, and so should your Will. Catholic Legacy allows you to update your Will anytime, at no cost, ensuring it always aligns with your current wishes.'
		},
		{
			img: './../../../../assets/images/jesus-in-hand.webp',
			title: 'Commitment to Your Faith',
			description: 'Our platform is designed to reflect your Catholic values and beliefs, ensuring that your Will is in harmony with your faith.'
		},
		{
			img: './../../../../assets/images/will-landing-2.png',
			title: 'Peace of Mind',
			description: 'By creating a Will with Catholic Legacy, you can have peace of mind knowing that your wishes will be carried out according to your faith and legal requirements.'
		},
		{
			img: './../../../../assets/images/old-couple-tea.webp',
			title: 'Support',
			description: 'While we do not have the authority to give legal advice, our team is available to assist you with any questions or concerns regarding using the platform, the sign-up process etc. and providing guidance when needed.'
		}
	];
	estateFeatures = [
		{
			img: './../../../../assets/images/estate-legacy-1.png',
			title: 'Save Money Without Compromising Quality',
			description: 'Hiring an estate attorney can be expensive, but it’s not always necessary for creating a simple, straightforward Will. Catholic Legacy offers a free, online Will creation and Catholic estate planning tool that’s been developed with input from experienced estate attorneys who are Catholic themselves.'
		},
		{
			img: './../../../../assets/images/estate-legacy-2.png',
			title: 'Built on Legal Expertise',
			description: 'Our platform was built in collaboration with top estate attorneys who understand the intricacies of estate planning. We’ve taken their insights and created a tool that allows you to generate a legally sound Will that reflects your values. You’re getting the best of both worlds: professional quality without the professional fees.'
		},
		{
			img: './../../../../assets/images/estate-legacy-3.png',
			title: 'Flexibility and Convenience',
			description: 'Creating your Will online with Catholic Legacy is quick, easy, and can be done from the comfort of your home. You can update your Will anytime, at no cost, to reflect changes in your life. If you decide you need additional legal advice, you can consult with an attorney afterward for a review or supervised signing.'
		},
		{
			img: './../../../../assets/images/estate-legacy-4.png',
			title: 'Commitment to Your Faith',
			description: 'Our platform is designed to reflect your Catholic values and beliefs, ensuring that your Will is in harmony with your faith.'
		},
		{
			img: './../../../../assets/images/estate-legacy-5.png',
			title: 'Peace of Mind',
			description: 'By creating a Will with Catholic Legacy, you can have peace of mind knowing that your wishes will be carried out according to your faith and legal requirements.'
		},
	];

	// features = [
	// 	{
	// 		img: './../../../../assets/images/estate-legacy-1.png',
	// 		title: 'Save Money Without Compromising Quality',
	// 		description: 'Hiring an estate attorney can be expensive, but it’s not always necessary for creating a simple, straightforward Will. Catholic Legacy offers a free, online Will creation and Catholic estate planning tool that’s been developed with input from experienced estate attorneys who are Catholic themselves.'
	// 	},
	// 	{
	// 		img: './../../../../assets/images/estate-legacy-2.png',
	// 		title: 'Built on Legal Expertise',
	// 		description: 'Our platform was built in collaboration with top estate attorneys who understand the intricacies of estate planning. We’ve taken their insights and created a tool that allows you to generate a legally sound Will that reflects your values. You’re getting the best of both worlds: professional quality without the professional fees.'
	// 	},
	// 	{
	// 		img: './../../../../assets/images/estate-legacy-3.png',
	// 		title: 'Flexibility and Convenience',
	// 		description: 'Creating your Will online with Catholic Legacy is quick, easy, and can be done from the comfort of your home. You can update your Will anytime, at no cost, to reflect changes in your life. If you decide you need additional legal advice, you can consult with an attorney afterward for a review or supervised signing.'
	// 	},
	// 	{
	// 		img: './../../../../assets/images/estate-legacy-4.png',
	// 		title: 'Commitment to Your Faith',
	// 		description: 'Our platform is designed to reflect your Catholic values and beliefs, ensuring that your Will is in harmony with your faith.'
	// 	},
	// 	{
	// 		img: './../../../../assets/images/estate-legacy-5.png',
	// 		title: 'Peace of Mind',
	// 		description: 'By creating a Will with Catholic Legacy, you can have peace of mind knowing that your wishes will be carried out according to your faith and legal requirements.'
	// 	},
		// {
		// 	img: './../../../../assets/images/happy-family.webp',
		// 	title: 'Online Estate Planning Made Easy',
		// 	description: 'Our platform guides you through creating a comprehensive Will in less than 30 minutes. It’s free to use, and you can update it anytime as your circumstances change.'
		// },
		// {
		// 	img: './../../../../assets/images/will6.webp',
		// 	title: 'Simple and Secure',
		// 	description: 'Catholic Legacy’s tool is designed to be easy for anyone to use, with step-by-step instructions and a secure platform that protects your information.'
		// },
		// {
		// 	img: './../../../../assets/images/hands.webp',
		// 	title: 'Aligned with Your Values',
		// 	description: 'Catholic Legacy ensures that your Will reflects your values, whether you want to leave assets to your family, support your church, or donate to causes you care about.'
		// },
		// {
		// 	img: './../../../../assets/images/files.webp',
		// 	title: 'Unlimited Updates for Life',
		// 	description: 'Your life changes, and so should your Will. Catholic Legacy allows you to update your Will anytime, at no cost, ensuring it always aligns with your current wishes.'
		// },
		// {
		// 	img: './../../../../assets/images/jesus-in-hand.webp',
		// 	title: 'Commitment to Your Faith',
		// 	description: 'Our platform is designed to reflect your Catholic values and beliefs, ensuring that your Will is in harmony with your faith.'
		// },
		// {
		// 	img: './../../../../assets/images/old-couple.webp',
		// 	title: 'Peace of Mind',
		// 	description: 'By creating a Will with Catholic Legacy, you can have peace of mind knowing that your wishes will be carried out according to your faith and legal requirements.'
		// },
		// {
		// 	img: './../../../../assets/images/old-couple-tea.webp',
		// 	title: 'Support',
		// 	description: 'While we do not have the authority to give legal advice, our team is available to assist you with any questions or concerns regarding using the platform, the sign-up process etc. and providing guidance when needed.'
		// }
	// ];

	customOptions2: OwlOptions = {
		loop: false,
		mouseDrag: false,
		touchDrag: true,
		pullDrag: false,
		dots: true,
		navSpeed: 700,
		navText: ['<img src="../../../assets/images/left-orange-arrow.webp">', '<img src="../../../assets/images/right-orange-arrow.webp">'],
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 1
			},
			1024: {
				items: 2
			},
			1200: {
				items: 2
			},
			1350: {
				items: 2
			}
		},
		nav: true
	}

	chunkedFeatures: any[] = [];
	chunkedEstateFeatures: any[] = [];
	products: any[] =[];
	willReasons = [
		{
			icon: './../../../../assets/images/people-inHand.png',
			title: 'Protect Your Loved Ones',
			description: 'A Will ensures your assets are distributed as you wish, avoiding legal disputes and providing clarity for your family. Without one, courts decide, which may not reflect your intentions.'
		},
		{
			icon: './../../../../assets/images/key-inhand.png',
			title: 'Control Your Estate',
			description: 'A Will lets you decide who inherits your property, cares for your children, and manages your assets. Take control and ensure your wishes are followed.'
		},
		{
			icon: './../../../../assets/images/purse.png',
			title: 'Avoid Costly Legal Fees',
			description: 'Creating a Will doesn’t always require an attorney. With Catholic Legacy, you can make a free, comprehensive Will online. Our platform saves time, money, and aligns with your values.'
		}
	];

	public faqData: any = [
		{
			_id: 1,
			sequence: 1,
			question: "Do I need an attorney to create a Will?",
			answer: "No. Catholic Legacy offers a free tool that allows you to create a comprehensive Will without the need for an attorney, although you can take what you create on our platform to an attorney for final review. Our platform is secure, easy to use, and aligned with your values.",
			isCollapsed: true
		},
		{
			_id: 2,
			sequence: 2,
			question: "Is creating a Will really free?",
			answer: "Yes! Catholic Legacy offers a completely free Will creation and online estate planning you can use to protect your estate and ensure your wishes are respected.",
			isCollapsed: true
		},
		{
			_id: 3,
			sequence: 3,
			question: "Can I update my Will as my circumstances change?",
			answer: "Absolutely. Catholic Legacy allows you to update your Will anytime, at no cost, so it always reflects your current wishes.",
			isCollapsed: true
		},
		{
			_id: 4,
			sequence: 4,
			question: "Is this service aligned with Catholic values?",
			answer: "Yes. Catholic Legacy is designed to help you create a Will that respects and reflects your values, whether you want to provide for your family, support your church, or donate to causes you care about.",
			isCollapsed: true
		},
		{
			_id: 5,
			sequence: 5,
			question: "How secure is my personal information on Catholic Legacy?",
			answer: "We prioritize data security and privacy. Your information is protected by industry-standard security measures.",
			isCollapsed: true
		},
		{
			_id: 6,
			sequence: 6,
			question: "Can I get help from a Catholic Legacy representative if I have questions?",
			answer: "While we do not have the authority to give legal advice, we can readily assist you with any questions or concerns regarding using the platform, the sign-up process etc.",
			isCollapsed: true
		}

	];
	public funeralPlanningFaqData: any = [
		{
			_id: 101,
			sequence: 1,
			question: "What is Catholic Legacy’s Funeral Planning Guide?",
			answer: "Catholic Legacy’s Funeral Planning Guide helps individuals and families document Catholic funeral wishes, organize important details, and prepare for Funeral Mass planning in one place.",
			isCollapsed: true
		},
		{
			_id: 102,
			sequence: 2,
			question: "Can I use this platform to plan ahead for myself?",
			answer: "Yes. You can document your own funeral wishes in advance, including readings, hymns, burial preferences, prayers, and other important details rooted in the Catholic faith.",
			isCollapsed: true
		},
		{
			_id: 103,
			sequence: 3,
			question: "Can I use this platform for a loved one who has passed away or is nearing the end of life?",
			answer: "Yes. Catholic Legacy can help families organize funeral arrangements, coordinate with the parish, and document important information during difficult times.",
			isCollapsed: true
		},
		{
			_id: 104,
			sequence: 4,
			question: "Can funeral plans be shared with the parish?",
			answer: "Yes. Funeral plans can be shared with parish staff, family members, funeral homes, and others involved in the planning process to help improve communication and coordination.",
			isCollapsed: true
		},
		{
			_id: 105,
			sequence: 5,
			question: "Why is this service free to use?",
			answer: "Catholic Legacy’s Funeral Planning Guide is provided free of charge through the support of Relevant Radio and partnering Catholic organizations that want to make faith-based funeral planning more accessible to individuals and families. The guide is designed to help document funeral wishes in a clear and organized way while making the planning process easier for loved ones and those assisting with funeral arrangements.",
			isCollapsed: true
		},
		{
			_id: 106,
			sequence: 6,
			question: "Does Catholic Legacy offer other services beyond the Funeral Planning Guide?",
			answer: "Yes. After creating an account, you can log in and explore additional Catholic Legacy planning tools, including the Catholic Will and Healthcare Directive, along with other resources designed to help document your wishes and support your loved ones.",
			isCollapsed: true
		},
		{
			_id: 107,
			sequence: 7,
			question: "Can I update funeral plans later?",
			answer: "Yes. Funeral plans can be updated anytime as wishes or circumstances change.",
			isCollapsed: true
		},
		{
			_id: 108,
			sequence: 8,
			question: "Is my information secure?",
			answer: "Yes. Catholic Legacy uses security measures designed to help protect personal information and sensitive data.",
			isCollapsed: true
		}
	];

	public healthcareDirectiveFaqData: any = [
		{
			_id: 201,
			sequence: 1,
			question: "What is a Healthcare Directive (Directive)?",
			answer: "A Healthcare Directive (Directive) is a legal document that allows someone to document healthcare wishes and appoint a trusted person to make medical decisions if they are unable to communicate for themselves.",
			isCollapsed: true
		},
		{
			_id: 202,
			sequence: 2,
			question: "Who should have a Healthcare Directive (Directive)?",
			answer: ` <p class="intro-text">
    A Healthcare Directive (Directive) can be beneficial for adults of all ages and stages of life, including:
  </p>

  <ul class="benefits-list">
    <li>
      <strong>Young adults and college students:</strong>
      Once someone turns 18, parents and loved ones may no longer automatically have access to medical information or decision-making authority during emergencies.
    </li>

    <li>
      <strong>Families and parents:</strong>
      Helps reduce uncertainty and provides clear guidance for loved ones during difficult medical situations.
    </li>

    <li>
      <strong>Older individuals:</strong>
      Ensures healthcare wishes are documented and respected as health needs change over time.
    </li>

    <li>
      <strong>Individuals facing upcoming surgeries or medical procedures:</strong>
      Helps prepare for unexpected complications by documenting medical preferences and appointing trusted decision-makers in advance.
    </li>
  </ul>`,
			isCollapsed: true
		},
		{
			_id: 203,
			sequence: 3,
			question: "Why should college students and young adults have a Healthcare Directive (Directive)?",
			answer: "Once someone turns 18, parents and loved ones may no longer automatically have access to medical information or healthcare decision-making authority during emergencies. A Directive (Directive) helps prepare for unexpected situations and ensures healthcare wishes are clearly documented.",
			isCollapsed: true
		},
		{
			_id: 204,
			sequence: 4,
			question: "Is Catholic Legacy’s Healthcare Directive (Directive) rooted in Catholic teaching?",
			answer: "Yes. Catholic Legacy’s Healthcare Directive (Directive) was developed to reflect Catholic teachings regarding the dignity of life, ethical healthcare decisions, and compassionate care, in consultation with the National Catholic Bioethics Center (NCBC).",
			isCollapsed: true
		},
		{
			_id: 205,
			sequence: 5,
			question: "Why is this service free to use?",
			answer: "Catholic Legacy’s Healthcare Directive (Directive) is provided free of charge through the support of Relevant Radio and partnering Catholic organizations that want to make faith-based end-of-life planning more accessible to individuals and families. The Healthcare Directive (Directive) is designed to help document medical wishes in a way that reflects Catholic teaching while providing clarity and peace of mind for loved ones.",
			isCollapsed: true
		},
		{
			_id: 206,
			sequence: 6,
			question: "Does Catholic Legacy offer other services beyond the Healthcare Directive (Directive)?",
			answer: "Yes. Catholic Legacy offers additional free planning tools beyond the Healthcare Directive (Directive). After logging in, users can explore and create other forms such as a Catholic Will, Funeral Planning Guide, and other end-of-life planning resources designed to reflect Catholic values and provide peace of mind for individuals and families.",
			isCollapsed: true
		},
		{
			_id: 207,
			sequence: 7,
			question: "Can I update my Healthcare Directive (Directive) later?",
			answer: "Yes. Healthcare Directives (Directive) can be updated anytime as wishes, health care needs, or personal circumstances change.",
			isCollapsed: true
		},
		{
			_id: 208,
			sequence: 8,
			question: "Can completed documents be shared with family members?",
			answer: "Yes. Documents can be downloaded and shared with family members, health care providers, caregivers, or trusted individuals as needed.",
			isCollapsed: true
		},
		{
			_id: 209,
			sequence: 9,
			question: "Is my information secure?",
			answer: "Yes. Catholic Legacy uses security measures designed to help protect personal and sensitive information.",
			isCollapsed: true
		}
	];
   pageTemplate = signal<string>('');


	chunkArray(arr: any[], chunkSize: number) {
		let chunked = [];
		for (let i = 0; i < arr.length; i += chunkSize) {
			chunked.push(arr.slice(i, i + chunkSize));
		}
		return chunked;
	}

	toggleAccordion(data: any) {
		data.isCollapsed = !data.isCollapsed; // Toggle the clicked accordion
	}

	// getTestimonail() {
	//   const params = {
	//     isActive: true
	//   }
	//   this.subscription.add(
	//     this.dataService.get(URLS.getTestimonail, params).subscribe(data => {
	//       if (data['code'] == 200) {
	//         this.testimonailData = data['data']['result'];

	//         this.testimonailData = this.testimonailData.filter((element: any) => {
	//           return element._id != '671658fc597a04112cc34fe1';
	//         });

	//         if (data['data']['result'].length <= 0) {
	//           this.noTestimonial = true;
	//         } else {
	//           this.noTestimonial = false;
	//         }
	//       } else {
	//         this.toastr.error(data['message'], "Error");
	//       }
	//     }, error => {
	//       this.toastr.error(error['message'], "Error");
	//     })
	//   )
	// }
	getTestimonail() {
		const params = {
			isActive: true
		}
		this.subscription.add(
			this.dataService.get(URLS.getTestimonail, params).subscribe(data => {
				if (data['code'] == 200) {
					this.testimonailData = data['data']['result'];

					this.testimonailData = this.testimonailData.filter((element: any) => {
						return element._id != '6523a7ca6936c3612a594d52';
					});

					if (data['data']['result'].length <= 0) {
						setTimeout(() => {
							this.noTestimonial = true;
						}, 500)
					} else {
						setTimeout(() => {
							this.noTestimonial = false;
						}, 500)
					}
				} else {
					this.toastr.error(data['message'], "Error");
				}
			}, error => {
				this.toastr.error(error['message'], "Error");
			})
		)
	}

	getSupportMissionTitle(defaultTitle: string): string {
		const custom = this.supportMissionSectionData?.['section_title'];
		if (this.supportMissionCustomFieldHasContent(custom)) {
			return String(custom).trim();
		}
		return defaultTitle;
	}

	getSupportMissionDescription(defaultDescription: string): string {
		const custom = this.supportMissionSectionData?.['section_description'];
		if (this.supportMissionCustomFieldHasContent(custom)) {
			return String(custom).trim().replace(/\n/g, '<br>');
		}
		return defaultDescription;
	}

	/** Use custom SOM copy in preview only when the API / form provided non-empty text (PLP & SLP). */
	private supportMissionCustomFieldHasContent(value: unknown): boolean {
		if (value == null) return false;
		const raw = String(value).replace(/\u00a0/g, ' ').trim();
		if (!raw) return false;
		const textOnly = raw.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, ' ').trim();
		return textOnly.length > 0;
	}

	get defaultSupportMissionDescription(): string {
		const orgName = this.basicSectionData?.['orgName'] || 'your organization';
		return `Your support empowers <b>${orgName}</b> to grow its mission.
			By choosing <b>${orgName}</b> in your bequest, you play a vital role in enriching lives and
			strengthening our community for the future. We deeply appreciate your thoughtful
			consideration in making a lasting impact.`;
	}

	fetchPreviewData() {
		this.isLoading = true
		setTimeout(() => {
			const previewDatas = this.previewData;
			this.pageTemplate.set(this.previewData['landingPageType'] || '');
			this.products= this.previewData.productsData || [];
			this.isactiveState = previewDatas?.['statisticsSectionData']?.['is_active']
			this.currentTier = previewDatas?.['tier'] || null
			this.aboutUsSectionData = previewDatas?.['aboutUsSectionData']?.['fields'] || null
			this.isSecondaryLandingPage = previewDatas?.['isSecondaryLandingPage'] === true
			this.isactiveAboutUs = this.isSecondaryLandingPage
				? previewDatas?.['aboutUsSectionData']?.['is_active'] === true
				: true
			this.isactiveSupportMission = this.isSecondaryLandingPage
				? previewDatas?.['supportMissionSectionData']?.['is_active'] === true
				: true
			this.basicSectionData = previewDatas?.['basicSectinData'] || null
			const brandingFields = previewDatas?.['brandingSectionData']?.['fields'] || null;
			if (this.basicSectionData && this.isSecondaryLandingPage && brandingFields) {
				// Use SLP Branding section values for the hero (logo/banner/description) in preview.
				this.basicSectionData['orgLogo'] =
					brandingFields['logo_url'] ?? this.basicSectionData?.['orgLogo'];
				this.basicSectionData['orgBannerImage'] =
					brandingFields['banner_image_url'] ?? this.basicSectionData?.['orgBannerImage'];
				this.basicSectionData['orgParternshipDescription'] =
					brandingFields['banner_description'] ?? this.basicSectionData?.['orgParternshipDescription'];
				this.basicSectionData['isBannerPreset'] = !!brandingFields['isBannerPreset'];
			}
			this.supportMissionSectionData = previewDatas?.['supportMissionSectionData']?.['fields'] || null
			this.signUpFormSectionData = previewDatas?.['signUpSectionData']?.['fields'] || null
			this.intiativeSectionData = previewDatas?.['initiativeSectionData']?.['fields'] || []
			this.isactiveInitiative = previewDatas?.['initiativeSectionData']?.['is_active']
			this.statisticSetionData = previewDatas?.['statisticsSectionData']?.['fields'] || []
			this.landingPageType = previewDatas?.['landingPageType']
			this.chunkedFeatures = this.chunkArray(this.features, 4);
			this.chunkedEstateFeatures = this.chunkArray(this.estateFeatures, 4);
			this.isLoading = false
			
			const banner = this.basicSectionData?.['orgBannerImage'];
			this.basicSectionData['orgBannerImage'] = banner
			? this.basicSectionData?.['isBannerPreset']
				? encodeURI(decodeURI(banner))
				: banner
			: '';

			// Ensure Read More/Read Less works after content renders (all landing types, desktop + mobile)
			setTimeout(() => {
				if (isPlatformBrowser(this.platformId)) {
					this.measureAll();
					this.setupObservers();
				}
			}, 150);

			if(this.signUpFormSectionData['where_align'] === 'left'){
				this.isReversed=true;
			}
			if(this.previewData?.['testimonialData'] && this.previewData?.['testimonialData']?.['fields']){
				this.testimonailData = this.previewData?.['testimonialData']?.['fields'].map((item: { title: string; description: string; image_url: string; rating: number; sequence: number }) => ({
								clientName: item.title,
								clientTestimony: item.description,
								thumbnail: item.image_url,
								rating: item.rating,
								sequence: item.sequence, // optional, if you want to keep sequence
							}));
			}
			else if(this.previewData?.['testimonialData']){
				this.testimonailData = this.previewData?.['testimonialData']?.map((item: { title: string; description: string; image_url: string; rating: number; sequence: number }) => ({
								clientName: item.title,
								clientTestimony: item.description,
								thumbnail: item.image_url,
								rating: item.rating,
								sequence: item.sequence, // optional, if you want to keep sequence
							}));
			}
			else{
             this.getTestimonail();
			}
		}, 700)
	}


	contactUs() {
		this.router.navigateByUrl('/contact-us');
	}


	validatePassword(password: string) {

	}
	onPasswordFocus() {
		this.passwordFocused = true;
	}

	onPasswordBlur() {
		if (this.f.password.status == 'VALID') {
			this.passwordFocused = false;
		}
	}

	onSubmit() {
		this.submitted = true;
		for (const i in this.f) {
			this.f[i].markAsDirty();
			this.f[i].updateValueAndValidity();
			this.f[i].markAsTouched();
		}
		// stop here if form is invalid
		if (this.createAccountForm.invalid) {
			return;
		}
		// stop here if agreement is not selected
		if (this.f.agreement._pendingTouched) {
			if (this.f.agreement.value === false) {
				return;
			}
		}

		const userInfo = {
			firstName: this.f.firstName.value,
			lastName: this.f.lastName.value,
			email: this.f.email.value,
			password: this.f.password.value,
			role: "user"
		}

		// const dobInput = document.getElementById('dateOfBirth') as HTMLInputElement;
		// const messageElement = document.getElementById('message');
		// const today = new Date();
		// const dob = new Date(dobInput.value);
		// let age = today.getFullYear() - dob.getFullYear();
		// const monthDiff = today.getMonth() - dob.getMonth();
		// if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
		//     age--;
		// }

		// if (age >= 18) {
		//     userInfo['dob'] = this.f.dateOfBirth.value;
		//     messageElement.textContent = '';
		// } else {
		//     messageElement.textContent = 'You must be at least 18 years old.';
		//     return;
		// }

		this.isLoading = true;

		this.subscription.add(
			this.dataService.post(URLS.signup, userInfo).subscribe(data => {
				if (data['code'] == 200) {
					this.isLoading = false;
					this.toastr.success(data['message']);
					// this.createAccountForm.reset();
					this.otpCounter();
					this.isTimer = true;
					this.isVerified = true;
					this.commonService.localStorageSet('verify-email', this.f.email.value);
					this.router.navigate(['/create-account/verify-email'])
				} else {
					this.isLoading = false;
					this.toastr.error(data['message']);
				}
			}, error => {
				this.isLoading = false;
				this.toastr.error(error['message']);
			})
		)

	}

	goLogin() {
		this.router.navigate(['/login']);
		this.isVerified = false;
	}

	goToRegisterPage(event: any) {
		if (event === 'go to register page') {
			this.isVerified = false;
		}
	}

	restrictFutureData() {
		var dtToday = new Date();
		var month = dtToday.getMonth() + 1;
		var day = dtToday.getDate();
		var year = dtToday.getFullYear();
		this.maxDate = year + '-' + month + '-' + day;
	}

	// confirm password validator
	public confirmValidator = (control: AbstractControl): { [s: string]: boolean } => {
		if (!control.value) {
			return { required: true };
		} else if (control.value !== this.f.password.value) {
			return { confirmPwd: true, error: true };
		}
		return {};
	};

	// resend otp
	resend() {
		this.isLoading = true;

		const data = {
			email: this.f.email.value,
		}

		this.subscription.add(
			this.dataService.post(URLS.emailVerification, data).subscribe(data => {
				if (data['code'] == 200) {
					this.isLoading = false;
					this.toastr.success(data['message']);
					this.code = null;
					this.otpCounter();
				} else {
					this.isLoading = false;
					this.toastr.error(data['message']);
				}
			}, error => {
				this.isLoading = false;
				this.toastr.error(error['message']);
			})
		)
	}

	otpCounter() {
		this.canResendOtp = false;
		this.counter = 900;
		this.countDown = timer(0, this.tick)
			.pipe(take(this.counter))
			.subscribe(() => {
				--this.counter;
				if (this.counter == 0) {
					this.canResendOtp = true;
					// this.isCreatePwd = true;
					this.countDown.unsubscribe();
				} else {
					// this.isCreatePwd = false;
				}
			});
	}

	// transfor counter in time format
	transform(value: number): string {
		const minutes: number = Math.floor(value / 60);
		return (
			('00' + minutes).slice(-2) +
			':' +
			('00' + Math.floor(value - minutes * 60)).slice(-2)
		);
	}

	handleDateInputChange(event: Event) {
		let inputValue = (event.target as HTMLInputElement).value;
		const messageElement = this.document.getElementById('message');
		if (this.isValidDate(inputValue)) {
			if (this.maxDate && inputValue > this.maxDate) {
				messageElement.textContent = 'Future date is not allowed.';
			}
			else {
				messageElement.textContent = '';
			}
		}
	}

	isValidDate(dateString: string): boolean {
		const date = new Date(dateString);
		return !isNaN(date.getTime());
	}

	onHeroCtaClick(event?: Event): void {
		event?.stopPropagation();

		if (!this.isSecondaryLandingPage) {
			this.redirectToWillForm();
			return;
		}

		if (this.pageTemplate() === 'healthcare_directive') {
			this.redirectToHealthcareDirectiveForm();
			return;
		}

		if (this.pageTemplate() === 'funeral_planning') {
			this.redirectToFuneralForm();
			return;
		}

		this.redirectToWillForm();
	}

	redirectToWillForm() {

		const userId = this.commonService.localStorageGet('userId')
		if (!userId) {
			sessionStorage.setItem('formId', '6490049fe7bc6b6649320fe5');
		}
		this.commonService.localStorageSet('my-form-status-id', '6490049fe7bc6b6649320fe5');
		this.router.navigate(['my-forms']);
	}

	redirectToFuneralForm(): void {
		const userId = this.commonService.localStorageGet('userId');
		if (!userId) {
			sessionStorage.setItem('formId', '64ccdf603f11d4fb4c0174a8');
		}
		this.commonService.localStorageSet('my-form-status-id', '64ccdf603f11d4fb4c0174a8');
		this.router.navigate(['my-forms']);
	}

	redirectToHealthcareDirectiveForm(): void {
		const userId = this.commonService.localStorageGet('userId');
		if (!userId) {
			sessionStorage.setItem('formId', '64e2f30f463b8795bcf3a85f');
		}
		this.commonService.localStorageSet('my-form-status-id', '64e2f30f463b8795bcf3a85f');
		this.router.navigate(['my-forms']);
	}

	  testimonials = [
    {
      name: "EMILIANO AQUILANI",
      image: "https://uifaces.co/our-content/donated/bUkmHPKs.jpg",
      text: "Dramatically maintain clicks-and-mortar solutions..."
    },
    {
      name: "ANNA ITURBE",
      image: "https://randomuser.me/api/portraits/men/78.jpg",
      text: "Dramatically maintain clicks-and-mortar solutions..."
    },
    {
      name: "LARA ATKINSON",
      image: "https://uifaces.co/our-content/donated/ukegoVAy.jpg",
      text: "Dramatically maintain clicks-and-mortar solutions..."
    },
    {
      name: "IAN OWEN",
      image: "https://uifaces.co/our-content/donated/ukegoVAy.jpg",
      text: "Dramatically maintain clicks-and-mortar solutions..."
    },
    {
      name: "MICHAEL TEDDY",
      image: "https://randomuser.me/api/portraits/men/35.jpg",
      text: "Dramatically maintain clicks-and-mortar solutions..."
    }
  ];
  currentIndex = 0;
getCardClass(i: number) {
  const total = this.carouselItems.length;

  if (total === 1) {
    // Only one card — always center
    return 'tcarousel-1-center';
  }

  if (total === 2) {
    // Special-case: avoid both left and right pointing to same index.
    // Make currentIndex the center; the other card will be shown on a single side.
    if (i === this.currentIndex) return 'tcarousel-1-center';

    // Alternate which side the other card sits on to make the animation feel natural:
    // when currentIndex is even show the other card on the right, when odd show it on the left.
    return (this.currentIndex % 2 === 0) ? 'tcarousel-1-right' : 'tcarousel-1-left';
  }

  // Default behavior for 3+ items (unchanged)
  if (i === this.currentIndex) return 'tcarousel-1-center';
  if (i === (this.currentIndex - 1 + total) % total) return 'tcarousel-1-left';
  if (i === (this.currentIndex + 1) % total) return 'tcarousel-1-right';
  return 'tcarousel-1-hidden';
}

get carouselItems() {
  if (!this.testimonailData) return [];

  if (this.testimonailData.length >= 3) {
    return this.testimonailData;
  }

  // Duplicate items until length = 3
  const extended = [...this.testimonailData];
  while (extended.length < 3) {
    extended.push(...this.testimonailData); // repeat
  }

  return extended.slice(0, 3); // ensure exactly 3
}


ngAfterViewInit(): void {
  if (!isPlatformBrowser(this.platformId)) return;

  setTimeout(() => {
    this.setupObservers();
    this.measureAll();
  }, 800);
}

ngOnDestroy(): void {
  this.resizeObs?.disconnect();
  this.mutationObs?.disconnect();
}


 measureWithClone(): void {
  if (!isPlatformBrowser(this.platformId)) return;

  const width = window.innerWidth;

  let maxLinesMob = 10;
  if (width < 500) maxLinesMob = 5;
  else if (width < 768) maxLinesMob = 7;
  else maxLinesMob = 10;

  /** ---------- DESKTOP ---------- **/
  const el = this.desc?.nativeElement;
  if (el) {
    const styles = window.getComputedStyle(el);
    const lh = parseFloat(styles.lineHeight) || this.estimateLineHeight(el);
    const height = el.scrollHeight;
    const lines = Math.round(height / lh);

    this.showReadMore = lines > 10;
  }

  /** ---------- MOBILE ---------- **/
  const mob = this.descMob?.nativeElement;
  if (mob) {
    const mobStyles = window.getComputedStyle(mob);
    const lhMob = parseFloat(mobStyles.lineHeight) || this.estimateLineHeight(mob);
    const heightMob = mob.scrollHeight;
    const linesMob = Math.round(heightMob / lhMob);

    this.showReadMoreMob = linesMob > maxLinesMob;
  }
}

/** fallback estimate for line-height if computed returns 'normal' */
 estimateLineHeight(el: HTMLElement): number {
	 if (!isPlatformBrowser(this.platformId)) return 16;
  const test = document.createElement('span');
  test.style.visibility = 'hidden';
  test.style.position = 'fixed';
  test.style.padding = '0';
  test.style.margin = '0';
  test.style.font = window.getComputedStyle(el).font;
  test.textContent = 'A';
  document.body.appendChild(test);
  const h = test.offsetHeight || 16;
  document.body.removeChild(test);
  return h;
}


	toggleDescription() {
		this.showFullDescription = !this.showFullDescription;

		if (!this.showFullDescription) {
			setTimeout(() => {

				if (this.desc && this.desc.nativeElement) {
					this.desc.nativeElement.scrollTop = 0;
				}

				if (this.descMob && this.descMob.nativeElement) {
					this.descMob.nativeElement.scrollTop = 0;
				}

			}, 50);
		} else {
			setTimeout(() => {

				// Desktop scroll to middle
				if (this.desc && this.desc.nativeElement) {
					const el = this.desc.nativeElement;
					el.scrollTop = (el.scrollHeight - el.clientHeight) / 2;
				}

				// Mobile scroll to middle
				if (this.descMob && this.descMob.nativeElement) {
					const elMob = this.descMob.nativeElement;
					elMob.scrollTop = (elMob.scrollHeight - elMob.clientHeight) / 2;
				}

			}, 50);
		}
	}


// setupObservers() {
//   this.measureAll();

//   const desktop = this.desc?.nativeElement;

//   // Desktop resize observer
//   this.resizeObs = new ResizeObserver(() => this.measureDesktop());
//   this.resizeObs.observe(desktop);

//   // Desktop mutation observer
//   this.mutationObs = new MutationObserver(() => {
//     setTimeout(() => this.measureDesktop(), 40);
//   });
//   this.mutationObs.observe(desktop, {
//     childList: true,
//     subtree: true,
//     characterData: true
//   });

//   // Fonts loaded (desktop fix)
//   document.fonts?.addEventListener("loadingdone", () => {
//     setTimeout(() => this.measureDesktop(), 60);
//   });


calculateOverflow(elRef: ElementRef, maxLines: number): boolean {
  const el = elRef.nativeElement;

  const clone = el.cloneNode(true) as HTMLElement;
  clone.classList.remove('collapsed', 'expanded', 'scroll');
  clone.style.visibility = 'hidden';
  clone.style.position = 'absolute';
  clone.style.left = '-9999px';
  clone.style.height = 'auto';
  clone.style.maxHeight = 'none';
  clone.style.overflow = 'visible';
  clone.style.display = 'block';
  clone.style.width = `${el.clientWidth}px`;
  clone.style.setProperty('-webkit-line-clamp', 'unset');

  document.body.appendChild(clone);

  const computed = window.getComputedStyle(el);
  const lineHeight = parseFloat(computed.lineHeight) || this.estimateLineHeight(el);

  const contentHeight = clone.scrollHeight;
  const lines = Math.ceil(contentHeight / lineHeight);

  document.body.removeChild(clone);

  return lines > maxLines;
}

measureAll() {
  this.measureDesktop();
  this.measureMobile();
}

measureDesktop() {
  if (!this.desc) return;
  // ✅ Force re-measurement
  const hasOverflow = this.calculateOverflow(this.desc, 10);
  this.showReadMore = hasOverflow;
  console.log('Desktop overflow detected:', hasOverflow); // Debug log
}


measureMobile() {
  if (!this.descMob) return;
  // ✅ Force re-measurement  
  const hasOverflow = this.calculateOverflow(this.descMob, 10);
  this.showReadMoreMob = hasOverflow;
  console.log('Mobile overflow detected:', hasOverflow); // Debug log
}

setupObservers() {
  // Prevent duplicate observers if called multiple times
  this.resizeObs?.disconnect();
  this.mutationObs?.disconnect();

  const desktop = this.desc?.nativeElement;

  if (!desktop) {
    console.warn('desc element not found');
    return;
  }

  // Observe desktop and mobile (if present)
  this.resizeObs = new ResizeObserver(() => {
    console.log('Resize detected');
    this.measureAll();
  });
  this.resizeObs.observe(desktop);
  if (this.descMob?.nativeElement) {
    this.resizeObs.observe(this.descMob.nativeElement);
  }

  this.mutationObs = new MutationObserver(() => {
    console.log('Content mutation detected');
    setTimeout(() => this.measureAll(), 100);
  });
  this.mutationObs.observe(desktop, { childList: true, subtree: true, characterData: true });
  if (this.descMob?.nativeElement) {
    this.mutationObs.observe(this.descMob.nativeElement, { childList: true, subtree: true, characterData: true });
  }

  if (document.fonts) {
    document.fonts.addEventListener('loadingdone', () => {
      console.log('Fonts loaded - remeasuring');
      setTimeout(() => this.measureAll(), 100);
    });
  }
}

}
